import React from 'react'
import "./About.css"
function About() {
    return (
        <div className="app2">
            <div className="h">
            <h1>About Balance Pad</h1>
            </div>
            <br />
            <br />
            <div className="conta">
            <p>This app is an ultimate pad which people need for a productive lifestyle.</p><br />
            <p>Online Classes are very difficult to follow and its very difficult to make notes while teacher is speaking , also you need something to keep track of what you will need to do the whole day! </p>
            <p>You need some break from your busy schedule after having doing lot of work all day long.</p>
            <p>A person can also need some consultance at some point related to mental health or stress related issues.</p>
            <p>Doing all these things whole day long, you need to motivate yourself that you did something great! </p><br />
            <p>Here comes the role of Balance Pad which makes sure you are balanced in your lifestyle and can accomplish all what is mentioned above!</p> <br />
            <p>You can chat to your Dr/consultant if you are having any stress,convert your lectures into text form and read from there,write your daily schedule to a todo list ,Send yourself a message if you accomplished something,Send accomplished messages to yourself, last but not the least land on to break page where you can take some break from your busy schedule and it is timed so that you dont waste more than 1hr there.</p>
            </div>
        </div>
    )
}

export default About
